import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	FRAME_MEDIUM_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame24 = (props: TQrFrameProps) => {
	const { previewMode } = props

	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 60
		const boxHeight = 10
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="frame-background"
				d="M7 28.5h12l-2 43H6.5L5 49.5 4 38H3l-1.5-1v-2.5l1-1L5 33z"
				fill={frameBackgroundColor}
			/>
			<path
				id="frame-background_2"
				d="M60.079 19.469c-.11.806.212 1.587.083 2.389-.051-.526-.349-.575-.836-.573q-19.76.03-39.517.012a9 9 0 0 1-.928-.097c-.345-.621-.303-1.247-.031-1.882.323-.126.661-.098.995-.1h39.097c.39.006.815-.09 1.137.25"
				fill={previewMode ? FRAME_MEDIUM_GREY : frameBackgroundColor}
			/>
			<g id="frame" fill={frameColor}>
				<path d="m18.704 19.457-.779-.17c-.727-.553-.943-1.27-.854-2.177.103-1.007.174-2.018.245-3.03.05-.702.1-1.405.16-2.107.065-.785.282-.973 1.054-.973h41.923c.79 0 1.025.238 1.078 1.024q.057.774.118 1.547v.003c.1 1.285.2 2.57.276 3.857.076 1.26-.579 1.948-1.847 2.037q-.235-.001-.47-.008-.236-.007-.473-.008h-39.3q-.561.001-1.132.005" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M62.94 68.175c.007-.017.06.23.06.325v2.117c-.114.88-.538 1.478-1.481 1.606H17.511l-.058-.006h-1.15l-.005-.003-10.329.003q-.097-1.392-.197-2.783c-.18-2.544-.361-5.089-.526-7.635-.034-.516-.162-.793-.73-.683-.404.078-.526-.094-.553-.502q-.375-5.611-.802-11.216c-.041-.549.025-.864.674-.736.386.077.47-.09.441-.477a725 725 0 0 1-.615-8.948c-.035-.554-.159-.807-.8-.774-1.142.045-1.836-.683-1.853-1.814q-.015-1.138.001-2.276c.025-.964.659-1.627 1.616-1.723q.073-.008.145-.01.063-.003.125-.008c.188-.018.39.004.592.025.386.041.765.082 1.024-.16.246-.227.354-.604.46-.981.046-.161.092-.322.148-.47q.115-.302.226-.608c.125-.341.25-.683.389-1.018.316-.757.791-1.344 1.687-1.426.243-.079.49-.067.737-.056q.13.007.26.008l2.291.002c2.447.005 5.396.01 7.488-.015l.09-1.46q.045-.713.08-1.424c.056-1.098.113-2.196.245-3.288a1 1 0 0 1 .076-.32l.018-.056a.8.8 0 0 1 .156-.255c.225-.083.452-.097.679-.087l.153-.001q18.931 0 37.856.022c.157 0 .314-.016.471-.032.333-.034.667-.068.996.05h.195c.558 0 1.038.02 1.11.722.135 1.095.193 2.198.251 3.3q.036.714.081 1.428c.103 1.55.192 3.104.282 4.655l.086 1.478q.157 2.668.31 5.334.176 3 .358 6 .102 1.676.198 3.352L62 49.266q.178 3.068.363 6.135.085 1.412.167 2.824v.01l.14 2.366c.143 2.42.206 4.848.268 7.274.004.051.002.24.001.3M18.125 29.13H8.698a5 5 0 0 0-.866.03c-.523.135-.827.477-.993.978-.09.277-.203.545-.315.813-.127.305-.254.61-.35.925q-.02.062-.049.125c-.068.157-.14.32.073.47 1.538.046 3.075.039 4.611.031.919-.004 1.837-.009 2.754-.002.427.003 1.137.001 1.879 0a204 204 0 0 1 2.492 0l.079-1.39q.055-.99.113-1.98m-.267 4.678c-2.7.007-6.001.01-9.125.012H8.73l-4.827.005q-.117 0-.236-.006c-.277-.01-.555-.018-.822.086-.781.538-.865 2.612-.123 3.212.223.094.453.087.683.08q.09-.004.18-.004h14.082zm-.275 4.837-.067-.001c-3.32 0-8.425 0-11.744.008a2 2 0 0 1-.164-.008c-.25-.018-.512-.036-.63.301-.064.704.006 1.402.076 2.099.032.32.064.642.083.964.051.845.115 1.69.178 2.536.07.927.14 1.854.193 2.782l.003.066c.018.355.037.711.25 1.021.195.194.43.184.666.173q.08-.004.16-.004h8.637c1.066 0 1.1.094 1.057 1.16-.04.995-.101 1.99-.163 2.983-.055.894-.11 1.787-.15 2.682-.032.719-.08 1.437-.128 2.155-.063.947-.126 1.894-.152 2.843a1 1 0 0 1-.282.738c-.245.163-.518.155-.788.147l-.183-.003h-7.13q-.065 0-.131-.004c-.238-.012-.49-.025-.59.303-.014 1.042.076 2.075.165 3.11.056.645.112 1.291.143 1.94.025.541.068 1.082.111 1.623.042.521.083 1.043.109 1.565l.005.128c.012.29.023.58.215.826.192.195.43.187.663.178l.159-.003c.878.009 1.756.005 2.635.001a125 125 0 0 1 4.099.029l.014.007a6 6 0 0 0 1.057-.07l-.006-.012c-.144-.34-.135-.702-.123-1.057.084-2.022.19-4.044.34-6.063q.056-1.686.152-3.368l.135-2.358q.08-1.413.163-2.824.181-3.056.355-6.112l.109-1.909q.094-1.67.193-3.34z"
				/>
			</g>
			<rect
				id="qr-background"
				x={24}
				y={27}
				width={31}
				height={31}
				rx={2}
				fill={qrBackgroundColor}
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 28.5,
							y: 31.5,
							width: 22,
							height: 22,
						}),
					}}
				/>
			) : (
				<MockQr x={28.5} y={31.5} width={22} height={22} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				xOffset={7.5}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
